import * as API from "./base";

const url = "/users/confirmation";

export const resend = ({ email }) =>
  API.post(url, { user: { email } }, { skipUrlNormalization: true });
